export default __webpack_public_path__ + "static/media/15_JYR.e0e46320.png";